import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
  Card,
  CardBody,
  CardHeader,
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Spinner
} from "@heroui/react";
import {
  Calculator,
  CurrencyCircleDollar,
  ArrowsDownUp
} from "@phosphor-icons/react";
import { DataCard } from "components/dataCard/dataCard";
import { applyMask } from "shared/utils/masks";
import { useRentalStats } from "../../hooks";

const ValueCreation = () => {
  const { stats: rentalStats, isLoading } = useRentalStats();

  if (isLoading) {
    return (
      <div className="flex h-[400px] items-center justify-center bg-neutral-50">
        <Spinner
          size="lg"
          color="primary"
          label="Waardecreatie gegevens laden..."
          classNames={{
            wrapper: "flex flex-col items-center gap-4",
            circle1: "border-b-moss-primary",
            label: "text-moss-primary font-medium"
          }}
        />
      </div>
    );
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Waardecreatie | Yally</title>
        </Helmet>
      </HelmetProvider>

      <div className="grid gap-4">
        <Card className="bg-white shadow-sm">
          <CardHeader>
            <h3 className="text-lg font-medium">Overzicht waardecreatie</h3>
          </CardHeader>
          <CardBody>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <DataCard
                title={applyMask(rentalStats?.valueCreation?.totalERV || 0, "valuta")}
                subtitle="Totale ERV"
                icon={<Calculator weight="duotone" />}
              />
              <DataCard
                title={applyMask(rentalStats?.valueCreation?.totalActualRent || 0, "valuta")}
                subtitle="Actuele huuropbrengst"
                icon={<CurrencyCircleDollar weight="duotone" />}
              />
              <DataCard
                title={`${Math.round(rentalStats?.valueCreation?.percentageDifference || 0)}%`}
                subtitle="Verschil t.o.v. ERV"
                icon={<ArrowsDownUp weight="duotone" />}
                label={rentalStats?.valueCreation?.percentageDifference > 0 ? "Boven ERV" : "Onder ERV"}
              />
            </div>
          </CardBody>
        </Card>

        <Card className="bg-white shadow-sm">
          <CardHeader>
            <h3 className="text-lg font-medium">Detail per unit</h3>
          </CardHeader>
          <CardBody>
            <Table>
              <TableHeader>
                <TableColumn>Unit</TableColumn>
                <TableColumn>ERV</TableColumn>
                <TableColumn>Actuele huur</TableColumn>
                <TableColumn>Verschil</TableColumn>
                <TableColumn>% Verschil</TableColumn>
              </TableHeader>
              <TableBody>
                {rentalStats?.valueCreation?.unitComparisons?.map((comparison: any) => (
                  <TableRow key={comparison.unitId}>
                    <TableCell>{comparison.unitId}</TableCell>
                    <TableCell>{applyMask(comparison.erv || 0, "valuta")}</TableCell>
                    <TableCell>{applyMask(comparison.actualRent || 0, "valuta")}</TableCell>
                    <TableCell>{applyMask(comparison.difference || 0, "valuta")}</TableCell>
                    <TableCell>
                      <span className={comparison.percentageDifference >= 0 ? "text-success" : "text-status-bad"}>
                        {Math.round(comparison.percentageDifference || 0)}%
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default ValueCreation;
